const readMoreInit = (block) => {
    const textBlocks = block?.[0] && block[0].querySelector(".bn-text__content") ? block[0].querySelector(".bn-text__content") : document.querySelector(".bn-text__content") ? Array.from(document.querySelectorAll(".bn-text__content")) : [];

    if(textBlocks.length > 0) {
        textBlocks.forEach(textBlock => {
            const readMoreButton = textBlock.parentNode.querySelector('.bn-text__button');

            readMoreButton.addEventListener('click', () => {
                textBlock.classList.toggle('--expanded');
                let innerText = readMoreButton.innerText;
                readMoreButton.textContent = readMoreButton.dataset.label;
                readMoreButton.dataset.label = innerText;
            });
        });
    }
};

const scrollanimationInit = (block) => {
    const scope = block?.[0] || document;
    // TEXT STROKE ANIMATION
    const headers = scope.querySelectorAll(".bn-text.scroll-animated-text");
    headers.forEach(h1 => {
        const children = Array.from(h1.children);
        children.forEach(child => {
            const clone = child.cloneNode(true);
            h1.appendChild(clone);
        });
    });
}

const textAnimationInit = (block) => {
    const scope = block?.[0] || document;
    const headers = scope.querySelectorAll(".bn-text.is-style-text-stroke h1");

    headers.forEach(h1 => {
        if (h1.dataset.split === "true") return;
        h1.dataset.split = "true";
        const split = new SplitType(h1, { types: "chars, words"});
        split.chars.forEach(char => {
            char.style.display = "inline-block";
            char.style.color = "transparent";
        });
        function isInViewport(el) {
            const rect = el.getBoundingClientRect();
            return rect.top < window.innerHeight && rect.bottom > 0;
        }
        if (isInViewport(h1)) {
            let anim = new TimelineMax({yoyo: true, repeat:-1});
            gsap.to(split.chars, {
                color: "#fff",
                stagger: 0.08,
                duration: 0.9,
                ease: "power2.out",
            });
            anim.from(h1, {
                scale: 0.9,
                duration: 0,
            }).to(h1, {
                scale: 1,
                duration: 15,
            }).to(h1, {
                scale: 0.9,
                duration: 15,
            });
        } else {
            gsap.to(split.chars, {
                scrollTrigger: {
                    trigger: h1,
                    start: "top 60%",
                    end: "top 30%",
                    scrub: 0.5
                },
                color: "#fff",
                stagger: 0.05,
                duration: 0.5,
                ease: "power2.out"
            });
        }
    });

    // HIGHLIGHTED TEXT ANIMATION
    const sections = scope.querySelectorAll(".is-style-highlighted-text-on-scroll");
    sections.forEach(section => {
        if (section.dataset.split === "true") return;
        section.dataset.split = "true";
        const paragraphs = section.querySelectorAll("p");
        const split = new SplitType(paragraphs, {
            types: "words, chars"
        });
        gsap.timeline({
            scrollTrigger: {
                trigger: section,
                start: "top 90%",
                end: "+=65%",
                scrub: 0.8
            }
        }).set(split.chars, {
            color: "white",
            stagger: 0.02
        });
    });
};

document.addEventListener("DOMContentLoaded", function () {
    if (!document.body.classList.contains('block-editor-page') && !document.body.classList.contains('block-editor-iframe__body')) {
        readMoreInit();
        textAnimationInit();
        scrollanimationInit();
    } else if (window.acf) {
        window.acf.addAction('render_block_preview/type=bn/text', readMoreInit, textAnimationInit);
    }
});